module.exports = __webpack_public_path__ + "static/interaction-1-3-e869276fb7ebd6ddcc4ce1047c576ea0.png";